import { Descriptions as AntdDescriptions, Tag } from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Descriptions from "../../general/antd/descriptions";
import PageDetails from "../../general/details";
import { useNavigate, useParams } from "react-router-dom";
import Spin from "../../general/antd/spin";
import AppContext from "../../../context/app/context";
import BadgeCharityContext from "../../../context/badge_charity/context";
import BadgeCharityContextProvider from "../../../context/badge_charity/provider";
import { ImCheckmark, ImCross } from "react-icons/im";
import Image from "../../general/antd/image";

interface Props {}

const BadgeCharity: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const { details, actions, loading } = useContext(BadgeCharityContext);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getDetails = async () => {
      id && (await actions.getDetails(Number(id)));
    };
    getDetails();
  }, [direction]);

  return (
    <>
      <PageDetails
        title={t("details")}
        subtitle={t("badge_charity")}
        buttonName={`${t("update_badge_charity")}`}
        onClick={() => navigate(`/badge-charities/update/${id}`)}
      >
        {loading.includes("details") ? (
          <Spin />
        ) : (
          <Descriptions size="small" column={1} bordered>
            <AntdDescriptions.Item label={t("id")}>
              {details?.id}
            </AntdDescriptions.Item>
            <AntdDescriptions.Item label={t("name")}>
              {details?.name ?? "-"}
            </AntdDescriptions.Item>
            <AntdDescriptions.Item label={t("note")}>
              {details?.note ?? "-"}
            </AntdDescriptions.Item>
            <AntdDescriptions.Item label={t("image")}>
              {details?.image ? (
                <Image
                  preview
                  height={80}
                  style={{
                    objectFit: "cover",
                  }}
                  width={80}
                  src={details?.image?.url}
                  alt={details?.image?.for}
                />
              ) : (
                <Tag color="red" title={t("not_found")} />
              )}
            </AntdDescriptions.Item>
          </Descriptions>
        )}
      </PageDetails>
    </>
  );
};

const BadgeCharityDetailsPage = () => {
  return (
    <BadgeCharityContextProvider>
      <BadgeCharity />
    </BadgeCharityContextProvider>
  );
};

export default BadgeCharityDetailsPage;